import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.fill.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Score',
  props: {
    score: {
      default: 0,
      type: Number
    }
  },
  computed: {
    scoreStatus: function scoreStatus() {
      var ceilScore = Math.ceil(this.score) / 2;
      var fullStar = Math.floor(ceilScore);
      var halfStar = ceilScore % 1;
      var starArr = new Array(5).fill(0).fill(1, 0, fullStar);
      halfStar && starArr.fill(0.5, fullStar, fullStar + 1);
      return starArr;
    }
  }
};